import PlatformOrgPicker from "./PlatformOrgPicker";
import OperatingAoiUploadButton from "./OperatingAoiUploadButton";

async function uploadOperatingAoi(file, name) {
  const form = new FormData();
  form.append("file", file);
  if (name) form.append("name", name);

  const res = await fetchWithAuth(
    "/api/v1/platform/operating-aois/import",
    {
      method: "POST",
      body: form,
    }
  );

  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.error || "Upload failed");
  }

  return res.json();
}

export default function PlatformAdminHeader({ title, subtitle, onAoiUploaded }) {
  return (
    <div
      className="
        h-10 px-4
        flex items-center justify-between
        bg-bg-soft
        border-b border-bg-border
        text-xs
        shrink-0
      "
    >
      {/* LEFT: TITLE */}
      <div className="flex items-center gap-3">
        <span className="font-semibold text-gray-200">
          {title}
        </span>

        {subtitle && (
          <span className="text-gray-400">
            {subtitle}
          </span>
        )}
      </div>

      {/* RIGHT: ORG PICKER */}
      <div className="flex items-center gap-3">
        <PlatformOrgPicker />
        <OperatingAoiUploadButton onUploaded={onAoiUploaded} />
      </div>
    </div>
  );
}